/*
This file is located in the main branch
Last time the file was updated (UTC): [09.04.2024 8:30:25]
Permissions to update outside the main branch: [false]
*/

import { getProps } from 'axios/propApi';
import { getCreditProductsList } from 'axios/tariffGroupApi';
import useApi from 'hooks/useApi';
import { CreditProduct } from 'models/api/creditProduct';
import { Prop } from 'models/api/prop';
import React, { createContext, useContext, useState } from 'react';
import { useQuery } from 'react-query';
import i18n from 'utils/i18n';

export type CreditProductsContextType = {
    creditProducts: CreditProduct[];
    isCreditProductsFetching: boolean;
    isTariffGroupCreditProductPropsFetching: boolean;
    tariffGroupCreditProductProps: Prop[];
};

const CreditProductsContext = createContext<CreditProductsContextType>(
    {} as CreditProductsContextType
);

export type CreditProductsProviderProps = {
    children: React.ReactNode;
};

const CreditProductsProvider = ({ children }: CreditProductsProviderProps) => {
    const [creditProducts, setCreditProducts] = useState<CreditProduct[]>([]);
    const [tariffGroupCreditProductProps, setTgCreditProductProps] = useState<Prop[]>([]);

    const api = useApi();

    const { isFetching: isCreditProductsFetching } = useQuery(
        'CreditProducts',
        () => getCreditProductsList(api, true),
        {
            onSuccess: (data) => {
                setCreditProducts(data);
            },
            enabled: !creditProducts?.length,
        }
    );

    const { isFetching: isTariffGroupCreditProductPropsFetching } = useQuery(
        'TariffGroupCreditProductProps',
        () => getProps(api, 'TgCreditProduct', i18n.language),
        {
            onSuccess: (p) => {
                p.map((prop: Prop) => (prop.values = [{ id: null, value: '' }]));
                setTgCreditProductProps(p);
            },
            enabled: !tariffGroupCreditProductProps?.length,
        }
    );

    return (
        <CreditProductsContext.Provider
            value={{
                creditProducts,
                isCreditProductsFetching,
                isTariffGroupCreditProductPropsFetching,
                tariffGroupCreditProductProps,
            }}
        >
            {children}
        </CreditProductsContext.Provider>
    );
};

const useCreditProductsList = () => {
    const context = useContext(CreditProductsContext);

    return context;
};

export { CreditProductsProvider, useCreditProductsList };
